export const woonenergieMessagebarColors = {
  messagebarBackground: '{{ brandSupport.lime }}',
  messagebarHoverBackground: '#8f9a25',
  messagebarText: '{{ textColors.textPrimary }}',
};
